<template>
  <div class="schools-dash-pie">
    <svg v-if="total > 0" class="schools-dash-pie__svg" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="28" fill="#f5f7fa" />
      <path
        v-for="(seg, idx) in segments"
        :key="idx"
        :d="seg.path"
        :fill="seg.color"
      />
      <circle cx="50" cy="50" r="16" fill="#fff" />
      <text x="50" y="52" text-anchor="middle" class="schools-dash-pie__center">{{ total }}</text>
    </svg>
    <div v-else class="schools-dash-pie__empty">暂无数据</div>
    <ul class="schools-dash-pie__legend">
      <li v-for="item in items" :key="item.name">
        <i :style="{ background: item.color }" />
        <span class="name">{{ item.name }}</span>
        <span class="val">{{ item.value }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SchoolsDashPie',
  props: {
    items: { type: Array, default: () => [] }
  },
  computed: {
    total() {
      return (this.items || []).reduce((sum, i) => sum + (Number(i.value) || 0), 0)
    },
    segments() {
      const list = (this.items || []).filter(i => Number(i.value) > 0)
      if (!list.length) return []
      const cx = 50
      const cy = 50
      const r = 28
      let angle = -Math.PI / 2
      const total = list.reduce((s, i) => s + Number(i.value), 0)
      return list.map(item => {
        const slice = (Number(item.value) / total) * Math.PI * 2
        const x1 = cx + r * Math.cos(angle)
        const y1 = cy + r * Math.sin(angle)
        angle += slice
        const x2 = cx + r * Math.cos(angle)
        const y2 = cy + r * Math.sin(angle)
        const large = slice > Math.PI ? 1 : 0
        const path = `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`
        return { path, color: item.color || '#409EFF' }
      })
    }
  }
}
</script>

<style scoped lang="less">
.schools-dash-pie {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 120px;

  &__svg {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
  }

  &__center {
    font-size: 12px;
    fill: #303133;
    font-weight: 600;
  }

  &__empty {
    width: 96px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 50%;
  }

  &__legend {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;

    li {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 1.8;
      color: #606266;

      i {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;
        flex-shrink: 0;
      }

      .name {
        flex: 1;
      }

      .val {
        color: #303133;
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }
}
</style>
